import { render, staticRenderFns } from "./UiSpinnerSmall.vue?vue&type=template&id=8a18e618&scoped=true&lang=pug"
import script from "./UiSpinnerSmall.vue?vue&type=script&lang=js"
export * from "./UiSpinnerSmall.vue?vue&type=script&lang=js"
import style0 from "./UiSpinnerSmall.vue?vue&type=style&index=0&id=8a18e618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a18e618",
  null
  
)

export default component.exports